import { render, staticRenderFns } from "./TreeComponent.vue?vue&type=template&id=57953540&scoped=true&"
import script from "./TreeComponent.vue?vue&type=script&lang=js&"
export * from "./TreeComponent.vue?vue&type=script&lang=js&"
import style0 from "./TreeComponent.vue?vue&type=style&index=0&id=57953540&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57953540",
  null
  
)

export default component.exports